/** What the How to connect dialog tells a person to type or paste. Placeholders only: no real token ever lands here. */

export const TOKEN_PLACEHOLDER = '<your token>';
const SERVER_NAME = 'wynxx-discover';

/** The configured public address, else the origin the app is served from (the web server proxies `/mcp` to the API). */
export function mcpUrl(configured: string | null): string {
  return configured ?? `${window.location.origin}/mcp`;
}

/** No header: Claude Code finds Wynxx's sign-in from the server's 401 and runs it when asked through /mcp. */
export function claudeCodeSignInCommand(url: string): string {
  return `claude mcp add --transport http ${SERVER_NAME} ${url}`;
}

export function claudeCodeTokenCommand(url: string): string {
  return `claude mcp add --transport http ${SERVER_NAME} ${url} --header "Authorization: Bearer ${TOKEN_PLACEHOLDER}"`;
}

export const CLAUDE_CODE_SIGN_IN_NEXT =
  'Then run /mcp in Claude Code, choose wynxx-discover and authenticate: your browser opens, you sign in to Wynxx Discover and choose Allow.';

/** Claude Desktop and Claude (web) share one connector list. */
export const CONNECTOR_STEPS = [
  'In Claude, open Settings → Connectors and choose Add custom connector.',
  'Give it a name, paste the MCP address above and choose Add, then Connect.',
  'Sign in to Wynxx Discover and choose Allow.',
];

/** A connector signs in; the header way exists only as a beta an Owner fills in for the whole organization. */
export const CONNECTOR_TOKEN_NOTE =
  'A custom connector signs in as above. Sending a fixed token in a request header is in beta for a limited set of organizations, and an Owner enters it for everyone in the organization, so a personal token does not fit there. Use a personal token in Claude Code instead.';

/** ChatGPT's custom connectors take OAuth only, so it has no token way. */
export const CHATGPT_STEPS = [
  'In ChatGPT, open Settings → Apps & Connectors → Advanced settings and turn on Developer mode (your workspace admin may need to allow it).',
  'Choose Create (add a connector), give it a name, paste the MCP address and pick OAuth as the authentication.',
  'Create, then sign in to Wynxx Discover and choose Allow.',
];

export const MENU_NAMES_VARY = 'Menu names may differ by plan.';
